var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiles-page',{attrs:{"title":"Администрирование","link-groups":_vm.linksGroups,"sm":"12","md":"6","xl":"4"}})}
var staticRenderFns = []

export { render, staticRenderFns }